/**
 * SVG render cache for milsymbol.
 * Avoids re-rendering the same SIDC at the same size.
 */

import ms from 'milsymbol';

const cache = new Map<string, string>();

/** Get or render SVG for a SIDC at a given size */
export function getSymbolSvg(sidc: string, size = 64): string {
  const key = `${sidc}:${size}`;
  const cached = cache.get(key);
  if (cached) return cached;

  const sym = new ms.Symbol(sidc, { size });
  const svg = sym.asSVG();
  cache.set(key, svg);
  return svg;
}

/** Check if a SIDC produces a valid symbol */
export function isValidSidc(sidc: string): boolean {
  if (!sidc || sidc.length < 10) return false;
  const sym = new ms.Symbol(sidc, { size: 24 });
  return sym.isValid() === true;
}

/** Clear the SVG cache (for testing) */
export function clearCache(): void {
  cache.clear();
}
